import * as yup from 'yup';

export const EmployeeInputs = {
    FIRSTNAME: 'firstname',
    MIDDLENAME: 'middlename',
    LASTNAME: 'lastname',
    SOCIAL_SECURITY_NUMBER: 'social_security_number',
    BIRTH_DATE: 'birth_date',
    MARITAL_STATUS: 'marital_status',
    ADDRESS: 'address',
    CITY: 'city',
    STATE: 'state',
    ZIP_CODE: 'zip_code',
    EMAIL: 'email',
    HOME_PHONE: 'home_phone',
    CELL_PHONE: 'cell_phone',
    IS_REG_EMAIL: 'is_reg_email',
    HIDE_STATUS: 'hide_status',
    MEDICAL_INSURANCE_AVAILABILITY: 'medical_insurance_availability',
    WORK_FROM_HOME: 'work_from_home',
    WORK_LOCATION: 'work_location',
    WORK_TIME_ZONE: 'work_time_zone',
    WAGE: 'wage',
    WAGE_PERIOD: 'wage_period',
    OVERTIME_EXEMPT_STATUS: 'overtime_exempt_status',
    SUPPLEMENT_TAX_METHOD: 'supplement_tax_method'
}

export const employeeSchema = yup.object({
    [EmployeeInputs.FIRSTNAME]: yup.string().required('Please enter firstname'),
    [EmployeeInputs.MIDDLENAME]: yup.string().required('Please enter middlename'),
    [EmployeeInputs.LASTNAME]: yup.string().required('Please enter lastname'),
    [EmployeeInputs.SOCIAL_SECURITY_NUMBER]: yup.string().required('This is required'),
    [EmployeeInputs.BIRTH_DATE]: yup.date('Please select date').required('This is required'),
    [EmployeeInputs.MARITAL_STATUS]: yup.string().required('This is required'),
    [EmployeeInputs.ADDRESS]: yup.string().required('This is required'),
    [EmployeeInputs.CITY]: yup.string().required('This is required'),
    [EmployeeInputs.STATE]: yup.string().required('This is required'),
    [EmployeeInputs.ZIP_CODE]: yup.string().required('This is required'),
    [EmployeeInputs.EMAIL]: yup.string().required('This is required').email('Please enter valid email'),
    [EmployeeInputs.HOME_PHONE]: yup.string().required('This is required'),
    [EmployeeInputs.CELL_PHONE]: yup.string().required('This is required'),
    [EmployeeInputs.IS_REG_EMAIL]: yup.boolean().required('This is required'),
    [EmployeeInputs.HIDE_STATUS]: yup.string().required('This is required'),
    [EmployeeInputs.MEDICAL_INSURANCE_AVAILABILITY]: yup.string().required('This is required'),
    [EmployeeInputs.WORK_FROM_HOME]: yup.string().required('This is required'),
    [EmployeeInputs.WORK_LOCATION]: yup.string().required('This is required'),
    [EmployeeInputs.WORK_TIME_ZONE]: yup.string().required('This is required'),
    [EmployeeInputs.WAGE]: yup.string().required('This is required'),
    [EmployeeInputs.WAGE_PERIOD]: yup.string().required('This is required'),
    [EmployeeInputs.OVERTIME_EXEMPT_STATUS]: yup.string().required('This is required'),
    [EmployeeInputs.SUPPLEMENT_TAX_METHOD]: yup.string().required('This is required')
})